const TERMS_MAP = {
  acceptableUsePolicyLink: {
    contentKey: 'acceptableUsePolicy',
    path: 'ua/acceptableuse-full',
  },
  buyerProtectionLink: {
    contentKey: 'buyerProtection',
    path: 'ua/paypal-buyer-protection',
  },
  cfsgpdsLink: {
    contentKey: 'cfsgpds',
    path: 'ua/cfsgpds-full',
  },
  collectionNoticeLink: {
    contentKey: 'collectionNotice',
    path: 'ua/ppcollection-notice',
  },
  creditCheckLink: {
    contentKey: 'creditCheck',
    path: 'ua/creditchk',
  },
  eCommunicationsPolicyLink: {
    contentKey: 'eCommunicationsPolicy',
    path: 'ua/esign-full',
  },
  feeInformationLink: {
    contentKey: 'feeInformation',
    useFunction: 'feeInformation',
  },
  nonAccountCheckoutLink: {
    contentKey: 'privacyPolicy',
    path: 'ua/privacy-full',
  },
  privacyPolicyLink: {
    contentKey: 'privacyPolicy',
    path: 'ua/privacy-full',
  },
  safetyAndSecurityLink: {
    contentKey: 'safetyAndSecurity',
    path: 'ua/paypal-safety-and-security',
  },
  sanctionsLink: {
    contentKey: 'sanctions',
    path: 'support/overseas-remittance',
  },
  serviceDescriptionLink: {
    contentKey: 'serviceDescription',
    path: 'ua/servicedescription-full',
  },
  termsAndConditionsLink: {
    contentKey: 'termsAndConditions',
    path: 'ua/legalhub-full',
  },
  termsLink: {
    contentKey: 'terms',
    path: 'ua/privacywax-full',
  },
  userAgreementLink: {
    contentKey: 'userAgreement',
    path: 'ua/useragreement-full',
  },
};

export { TERMS_MAP };
